const GLOBAL_VARS_OBJECT_KEY = '_FT_GLOBAL_VARS'
export const GLOBAL_VAR_KEYS = { AUTO_SCALE_ZOOM: 'autoScaleZoom' }

export const storeGlobalBrowserVariable = (variableName, variableValue) => {
  if (!window[GLOBAL_VARS_OBJECT_KEY]) window[GLOBAL_VARS_OBJECT_KEY] = {}

  window[GLOBAL_VARS_OBJECT_KEY][variableName] = variableValue
}

export const fetchGlobalBrowserVariable = (variableName) => {
  if (!window[GLOBAL_VARS_OBJECT_KEY]) return undefined

  return window[GLOBAL_VARS_OBJECT_KEY][variableName]
}
